import { styled } from 'styled-components';

export const MetaStrip = styled.div`
  display: flex;
  flex-wrap: wrap;
  gap: 16px;
  margin-bottom: 16px;
  color: ${({ theme }) => theme.textColor};
`;
